import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const serviceCategories = [
  {
    title: 'Digital Marketing',
    // icon: '📢',
    icon: '',

    services: [
      { name: 'Social Media Marketing', desc: 'Grow brand presence & engagement across all platforms.', path: '/services/social-media-marketing', icon: '📱' },
      { name: 'Social Media Optimization', desc: 'Maximize organic reach with optimized social profiles.', path: '/services/social-media-optimization', icon: '🔍' },
      { name: 'WhatsApp Marketing', desc: 'Direct customer communication at scale.', path: '/services/whatsapp-marketing', icon: '💬' },
      { name: 'Google Ads', desc: 'Drive targeted traffic with expert PPC campaigns.', path: '/services/google-ads', icon: '🎯' },
      { name: 'Meta Ads', desc: 'Facebook & Instagram ads that convert.', path: '/services/meta-ads', icon: '📊' },
    ]
  },
  {
    title: 'Website Services',
    // icon: '🌐',
    icon: '',

    services: [
      { name: 'Website Design', desc: 'Beautiful, conversion-focused website designs.', path: '/services/website-design', icon: '🎨' },
      { name: 'Website Development', desc: 'High-performance websites built to last.', path: '/services/website-development', icon: '⚙️' },
      { name: 'Domain & Hosting', desc: 'Reliable hosting solutions for your business.', path: '/services/domain-hosting', icon: '🖥️' },
      { name: 'Website Maintenance', desc: 'Keep your website fast, secure, and updated.', path: '/services/website-maintenance', icon: '🔧' },
      { name: 'E-Commerce Development', desc: 'Powerful online stores that sell.', path: '/services/ecommerce-development', icon: '🛒' },
    ]
  },
  {
    title: 'Creative Services',
    icon: '',
    // icon: '🎨',

    services: [
      { name: 'Graphic Design', desc: 'Stunning visuals that tell your brand story.', path: '/services/graphic-design', icon: '✏️' },
    ]
  },
];

export default function Services() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.1 });
    document.querySelectorAll('.animate-on-scroll').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="services-page">


     <section className="page-hero">
  <div className="container page-hero-content hero-animate">
    <span className="section-tag">What We Offer</span>
    <h1>Our <span>Services</span></h1>
    <p>
      Complete digital solutions under one roof — from strategy and design 
      to development and advertising.
    </p>
  </div>
</section>

      <section className="services-listing">
        <div className="container">
          {serviceCategories.map((cat, ci) => (
            <div className="service-category animate-on-scroll" key={ci}>
              <div className="cat-header">
                <span className="cat-icon">{cat.icon}</span>
                <h2>{cat.title}</h2>
              </div>
              <div className="cat-grid">
                {cat.services.map((s, si) => (
                  <Link to={s.path} className="service-item" key={si}>
                    <div className="si-icon">{s.icon}</div>
                    <div className="si-info">
                      <h3>{s.name}</h3>
                      <p>{s.desc}</p>
                    </div>
                    <span className="si-arrow">→</span>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="services-cta animate-on-scroll">
        <div className="container">
          <div className="sc-card">
            <h2>Not Sure Which Service You Need?</h2>
            <p>Talk to our experts and get a free consultation tailored to your business goals.</p>
            <Link to="/contact" className="btn-primary">Get Free Consultation →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
